import * as React from 'react'

import { XIcon } from 'lucide-react'
import { observer } from 'mobx-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { Kbd } from '~/client/src/shared/components/shadcn-ui/kbd'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import WorkflowComposerStore from './WorkflowComposer.store'

interface IProps {
  store: WorkflowComposerStore
}

// The minimized form's controls, docked at the trailing end of the markup toolbar's common
// wrapper (whose leading grip drags the whole cluster). px-3/py-2 keeps it 48px tall to line
// up with the toolbar buttons. "Open workflow" routes through openWorkflowForm (also leaves
// edit mode). The X is the dock's analog of the expanded form's Cancel — same store.close
// (discard guard included).
const WorkflowComposerMinimized: React.FC<IProps> = observer(({ store }) => (
  <div
    data-testid="workflow-composer-minimized"
    className="tw:flex tw:items-center tw:gap-1.5 tw:rounded-lg tw:bg-popover tw:px-3 tw:py-2 tw:shadow-lg"
  >
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={store.close}
            disabled={store.isSubmitting}
            aria-label={Localization.translator.cancel}
            data-testid="workflow-composer-cancel"
            className="tw:text-muted-foreground"
          />
        }
      >
        <XIcon aria-hidden="true" />
      </TooltipTrigger>
      <TooltipContent>{Localization.translator.cancel}</TooltipContent>
    </Tooltip>
    <Button
      variant="primary-outline"
      onClick={store.openWorkflowForm}
      data-testid="workflow-composer-open"
    >
      {Localization.translator.openWorkflowForm}
      <Kbd data-icon="inline-end">↵</Kbd>
    </Button>
  </div>
))

export default WorkflowComposerMinimized
